var ghost = "dialog-trigger-button__ghost__OrMww";
var secondary = "dialog-trigger-button__secondary__w-GC7";
var dialogTriggerButton = "dialog-trigger-button__dialogTriggerButton__bjzvt";
var lg = "dialog-trigger-button__lg__yHNjf";

export { dialogTriggerButton, ghost, lg, secondary };
//# sourceMappingURL=dialog-trigger-button.module.css.js.map
